<base-support-modal [title]="title" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Заблокировать'" (onOk)="ok()" >
	<p>Причины блокировки:</p>
	<textarea [(ngModel)]="message" class="form-control" rows="3"></textarea>
	<br>
	<p>Пользователь получит письмо на email: <strong>{{email}}</strong></p>
</base-support-modal>
